 



import React, { useEffect, useState } from "react";
 import "./ImageOffcanvas.css";
 import { Link } from "react-router-dom";
import { useUser } from "../../../context/UserContext"; // Ensure this provides { user }

const ImageOffcanvas = () => {
     const { user } = useUser();
      const isLoggedIn = !!user;

  const [open, setOpen] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setOpen(true);
    }, 2000); // ⏱️ auto open after 5 sec

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {/* BACKDROP */}
      <div
        className={`backdrop ${open ? "show" : ""}`}
        onClick={() => setOpen(false)}
      />

      {/* SLIDE PANEL */}
      <div className={`slide-panel ${open ? "open" : ""}`}>
        <button className="close-btn" onClick={() => setOpen(false)}>
          ✕
        </button>

        <img
          src="assetsfront/images/offer.png"
          alt="offer"
          className="popup-img"
        />

        {/* <h5 >Special Offer</h5> */}
       <h4 style={{color: "#ff0b0b",background: "yellow",borderRadius: "15px"}}> Register free, No fees to begin—5 hours of free videos, then ₹10/hour.</h4>
{isLoggedIn ? (
   <Link to='../studentlogin' className="btn btn-warning mt-2 mb-4">
    RECHARGE Now
  </Link>
) : (
    <Link to='../our-batches' className="btn btn-warning mt-2 mb-4">
    RECHARGE Now
  </Link>
)}

       
      </div>
    </>
  );
};

export default ImageOffcanvas;





 
 